import AlPrestamo from "@/pixels/providers/alprestamo";
import { getParameterByName, getEnvironment } from "@/utils";

jest.mock("@/utils", () => ({
  getEnvironment: jest.fn(),
  getParameterByName: jest.fn()
}));

describe("Píxel AlPrestamo", () => {
  beforeEach(() => {
    jest.clearAllMocks();

    global.fetch = jest.fn(() =>
      Promise.resolve({
        json: jest.fn(() => Promise.resolve())
      })
    );
  });

  it("deberia enviar el postback cuando tipoPaquete y tracking_id existen", async () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: "01"
          }
        }
      }
    };

    // Mockear environment productivo
    getEnvironment.mockReturnValueOnce({ name: "prod" });
    getParameterByName.mockReturnValueOnce("abc123");

    await AlPrestamo.enviar(context);

    expect(fetch).toHaveBeenCalledWith(
      "https://api.ar.alprestamo.io/bid/postback/only-by-url?tracking_id=abc123&status=granted&product=nomina"
    );
  });

  it("NO deberia enviar el postback cuando NO es paquete", async () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {}
        }
      }
    };

    // Mockear environment productivo
    getEnvironment.mockReturnValueOnce({ name: "prod" });
    getParameterByName.mockReturnValueOnce("abc123");

    await AlPrestamo.enviar(context);

    expect(fetch).not.toHaveBeenCalled();
  });

  it("NO deberia enviar el postback cuando no hay tracking_id", async () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: "09"
          }
        }
      }
    };

    getEnvironment.mockReturnValueOnce({ name: "prod" });
    getParameterByName.mockReturnValueOnce(undefined);

    await AlPrestamo.enviar(context);

    expect(fetch).not.toHaveBeenCalled();
  });
});
